import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import useAgency from 'features/Agency/useAgency';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import KTImageInput from 'general/components/OtherKeenComponents/FileUpload/KTImageInput';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import CustomDropdown3 from 'general/components/Others/CustomDropdown3';
import CustomDropdownMultiChoiceView, { CustomDropdownMultiChoiceDirections } from 'general/components/quybka/Others/CustomDropdownMultiChoiceView';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import miscHelper from 'general/helpers/miscHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

DialogNotificationAddView.propTypes = {
    item: PropTypes.object,
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
};

function DialogNotificationAddView({ item, onCancel, onDone }) {
    // MARK: ---- PROPERTIES ----
    const { user } = useSelector((state) => state.auth);
    const editMode = !!item;
    const [loading, setLoading] = useState(false);
    const [readyToValidate, setReadyToValidate] = useState(false);
    const [selectedUser, setSelectedUser] = useState();
    const [category, setCategory] = useState('');
    const [link, setLink] = useState('');
    const [title, setTitle] = useState('');
    const [releaseDate, setReleaseDate] = useState('');
    const [message, setMessage] = useState('');
    useEffect(() => {
        if (item) {
            if (!item?.userId) {
                if (item?.role === ChargeConstants.UserRole.DRIVER) {
                    setSelectedUser({ id: 'ALL_DRIVER', name: 'Tất cả tài xế', role: 'DRIVER' })
                } else if (item?.role === ChargeConstants.UserRole.AGENCY && !item?.subRole) {
                    setSelectedUser({ id: 'ALL_AGENCY', role: 'AGENCY', name: 'Tất cả đối tác' })
                } else if (item?.role === ChargeConstants.UserRole.AGENCY && !!item?.subRole) {
                    setSelectedUser({ id: `ALL_${item?.subRole}`, role: item?.subRole, name: ChargeHelper.Utils.getNotificationReceiverName(item?.subRole) })
                }
            } else {
                setSelectedUser({
                    id: item?.user?.userId,
                    name: item?.user?.fullname,
                    role: item?.role,
                    item: item?.user,
                })
            }

            setCategory(item?.category);
            setLink(item?.metadata?.link);
            setTitle(item?.title);
            setReleaseDate(item?.releaseDate);
            setMessage(item?.message);
        }
    }, [item]);
    const userRoleRef = useRef(null);
    const userRoleOptions = [
        {
            role: ChargeConstants.UserRole.DRIVER,
            value: ChargeConstants.UserRole.DRIVER,
            name: 'Tài xế',
        },
        {
            role: ChargeConstants.UserRole.AGENCY,
            value: ChargeConstants.UserRole.AGENCY,
            name: 'Đối tác',
        },
    ]
    const agencyRoleOptions = [
        {
            id: 'ALL_AGENCY',
            role: 'AGENCY',
            name: 'Tất cả đối tác',
            hasThirdLevel: false,
        },
        {
            role: AgencyConstants.AgencyRole.SALE,
            name: 'Đại lý',
            hasThirdLevel: true,
        },
        {
            role: AgencyConstants.AgencyRole.INVESTOR,
            name: 'NĐT nhượng quyền',
            hasThirdLevel: true,
        },
        {
            role: AgencyConstants.AgencyRole.GROUP,
            name: 'Nhà đầu tư HTKD',
            hasThirdLevel: true,
        },
        {
            role: AgencyConstants.AgencyRole.LANDLORD,
            name: 'Chủ mặt bằng',
            hasThirdLevel: true,
        },
    ]

    const dropdownUserEl = useMemo(() => {
        return (
            <CustomDropdown3
                ignoreConfirmClick
                name="userId"
                id="userId"
                toggleElement={
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                             ${editMode ? 'disabled' : ''}
                             ${readyToValidate && !Utils.isValid(selectedUser) ? 'border-invalid' : ''}`}
                        type="button"
                    >
                        {selectedUser?.name || 'Chọn người nhận'}
                    </button>
                }
                selectedValue={selectedUser}
                dropdownMenuItems={userRoleOptions}
                dropdownMenuClassName="overflow-auto w-100 position-relative"
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                titleSearchable={false}
                secondLevelTitle={userRoleRef.current?.role === 'DRIVER' ? 'Chọn tài xế' : 'Chọn đối tác'}
                thirdLevelTitle="Chọn người nhận"
                getSubItems={async (item) => {
                    userRoleRef.current = item || userRoleRef.current;
                    const params = Utils.filterParams({
                        page: item?.page || 0,
                        limit: 10,
                        q: item?.q || '',
                    });
                    try {
                        if (userRoleRef.current?.role === 'DRIVER') {
                            const data = await ChargeHelper.API.Driver.requestGetDriverList(params);
                            const values = data.drivers?.filter((driver) => driver?.fullname)?.map((driver) => ({
                                id: driver?.userId,
                                name: driver?.fullname,
                                email: driver?.email,
                                item: driver,
                                role: 'DRIVER',
                            }));
                            return {
                                values: item?.page === 0 ? [{ id: 'ALL_DRIVER', name: 'Tất cả tài xế', role: 'DRIVER' }, ...(values || [])] : values || [],
                                total: data.total
                            };
                        } else {
                            if (!item?.hasThirdLevel) {
                                return {
                                    values: agencyRoleOptions.map((agencyRole) => ({
                                        id: agencyRole?.id,
                                        name: agencyRole?.name,
                                        role: agencyRole?.role,
                                        hasThirdLevel: agencyRole?.hasThirdLevel,
                                    })),
                                    total: 0,
                                };
                            } else if (item?.hasThirdLevel) {
                                const data = await AgencyHelper.API.requestGetAgencyList({ ...params, role: item?.role });
                                const values = data.agencies?.filter((agency) => agency?.name)?.map((agency) => ({
                                    id: agency?.users?.[0]?.userId,
                                    name: agency?.name,
                                    email: agency?.email,
                                    item: agency,
                                    hasThirdLevel: false,
                                    role: item?.role,
                                }));
                                return {
                                    values: item?.page === 0
                                        ? [{ id: `ALL_${item?.role}`, name: `Tất cả ${AgencyHelper.Utils.getAgencyRoleShortName(item?.role)}`, role: item?.role }, ...(values || [])]
                                        : values || [],
                                    total: data.total
                                };
                            }
                        }
                        return { values: [], total: 0 };
                    } catch (error) {
                        return { values: [], total: 0 };
                    }
                }}
                onChange={(value) => setSelectedUser(value)}
                isDropdownForm
                searchable
                searchFormClassName="mx-3 my-1 search-form-border"
                titleType="name"
                subTitleType="email"
                defaultShowThirdLevel={selectedUser?.id && userRoleRef.current?.role !== 'DRIVER' && userRoleRef.current?.role !== 'AGENCY'}
                defaultShowType="role"
                disabled={editMode}
            />
        );
    }, [selectedUser, userRoleOptions, agencyRoleOptions, editMode]);

    const notificationCategoryOptions = useMemo(() => {
        if (selectedUser?.role === 'DRIVER') {
            return [
                {
                    value: ChargeConstants.NotificationCategory.CHARGE,
                    name: 'Sạc xe & Giao dịch',
                },
                {
                    value: ChargeConstants.NotificationCategory.EVG,
                    name: 'EVG',
                },
            ]
        } else {
            return [
                {
                    value: ChargeConstants.NotificationCategory.BUSINESS,
                    name: 'Kinh doanh',
                },
                {
                    value: ChargeConstants.NotificationCategory.OPERATION,
                    name: 'Vận hành',
                },
                {
                    value: ChargeConstants.NotificationCategory.PROMOTION,
                    name: 'Khuyến mãi',
                },
                {
                    value: ChargeConstants.NotificationCategory.OTHER,
                    name: 'Khác',
                },
            ]
        }
    }, [selectedUser])

    // MARK: ---- FUNCTIONS ----
    const handleSubmit = async () => {
        setReadyToValidate(true);
        if (
            !Utils.isValid(selectedUser) ||
            !Utils.isValid(category) ||
            !Utils.isValid(title) ||
            !Utils.isValid(message)
        ) {
            ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
            return;
        }

        if (Utils.isValid(link) && !link.match(AppConfigs.regex.url)) {
            ToastHelper.showError('Đường dẫn không hợp lệ');
            return;
        }
        let params = {
            userId: typeof selectedUser?.id === 'number' ? selectedUser.id : null,
            category,
            title,
            message,
            createdBy: user?.userId,
            releaseDate: releaseDate || moment().format('YYYY-MM-DD HH:mm'),
            metadata: {
                link
            },
            isSent: 0,
            isRead: 0,
            public: 0,
            role: typeof selectedUser?.id === 'number'
                ? null
                : ['ADMIN', 'DRIVER', 'MAINTAINER'].includes(selectedUser?.role)
                    ? selectedUser?.role
                    : 'AGENCY',
            subRole: typeof selectedUser?.id === 'number'
                ? null
                : ['SALE', 'INVESTOR', 'GROUP', 'LANDLORD'].includes(selectedUser?.role)
                    ? selectedUser?.role
                    : null,
        };
        params = _.pickBy(params, (value) => value !== null && value !== undefined && value !== '');

        console.log({ params });
        setLoading(true);
        if (!editMode) {
            const res = await ChargeHelper.API.Notification.requestAddNotification(params);
            if (_.isBoolean(res) && res) {
                ToastHelper.showSuccess('Thêm mới thông báo thành công');
                onDone && onDone();
            } else if (_.isString(res)) {
                ToastHelper.showError(res);
            }
        } else {
            const res = await ChargeHelper.API.Notification.requestUpdateNotification(item?.notificationId, params);
            if (_.isBoolean(res) && res) {
                ToastHelper.showSuccess('Chỉnh sửa thông báo thành công');
                onDone && onDone();
            } else if (_.isString(res)) {
                ToastHelper.showError(res);
            }
        }
        setLoading(false);
    };

    return (
        <div>
            <div className="row m-0 p-0 px-2 mt-4">
                {/* avatar */}
                <div className="col-12 mb-4 px-2" >
                    <div className='p-4'
                        style={{
                            border: `1px solid ${AppColors.danger}`,
                            borderRadius: 10,
                            backgroundColor: '#FFF6F6'
                        }}>
                        <div style={UIHelper.buildFontStyle('700', '14px', AppColors.danger)}>
                            Lưu ý:
                        </div>
                        <div style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[800])}>
                            Thông báo sẽ được gửi ngay đến người nhận nếu không đặt lịch. Hãy kiểm tra kỹ nội dung trước khi tạo.
                        </div>
                    </div>
                </div>
                {/* fullname */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Người nhận', true)}
                    {dropdownUserEl}
                </div>
                {/* email */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Danh mục', true)}
                    <KTBSDropdown
                        toggleElement={({ showError }) => (
                            <button
                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between 
                                    ${readyToValidate && !Utils.isValid(category) ? 'border-invalid' : ''}
                                    ${!selectedUser ? 'dropdown-disabled' : ''}
                                    `}
                                type="button"
                            >
                                {_.find(
                                    notificationCategoryOptions,
                                    (item) => item.value === category
                                )?.name ?? 'Chọn danh mục'}
                            </button>
                        )}
                        selectedValue={category}
                        dropdownMenuItems={notificationCategoryOptions}
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        dropdownMenuClassName="overflow-auto w-100"
                        onChange={(value) => setCategory(value)}
                        enableCheckValid
                        isDropdownForm={true}
                        disabled={!selectedUser}
                    />
                </div>
                {/* link */}
                <div className="col-md-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Liên kết đến')}
                    <KTFormInput
                        type={KTFormInputType.text}
                        placeholder="Dán URL tại đây (ví dụ: https://...)"
                        name="link"
                        value={link}
                        onChange={(value) => {
                            setLink(value);
                        }}
                        isValid={Utils.isValid(link)}
                        isTouched={readyToValidate}
                    />
                </div>
                {/* title */}
                <div className="col-md-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Tiêu đề', true)}
                    <KTFormInput
                        type={KTFormInputType.text}
                        placeholder="Nhập tiêu đề"
                        name="title"
                        value={title}
                        onChange={(value) => {
                            setTitle(value);
                        }}
                        enableCheckValid={readyToValidate}
                        isValid={Utils.isValid(title)}
                        isTouched={readyToValidate}
                    />
                </div>
                {/* releaseDate */}
                <div className="col-md-12 mb-2 px-2">
                    {UIHelper.buildFormLabel('Đặt lịch')}
                    <KTFormInput
                        type={KTFormInputType.datetime}
                        placeholder="DD/MM/YYYY - HH:MM"
                        name="releaseDate"
                        value={releaseDate}
                        onChange={(value) => {
                            setReleaseDate(value);
                        }}
                        isTouched={readyToValidate}
                    />
                </div>
                <div className='mb-4' style={UIHelper.buildFontStyle('500', '12px', AppColors.gray[700])}>
                    Nếu không đặt lịch, thông báo sẽ được gửi tới người nhận ngay lập tức.
                </div>
                {/* message */}
                <div className="col-12 mb-4 px-2">
                    <div>
                        {UIHelper.buildFormLabel('Nội dung', true)}
                        <KTFormTextArea
                            placeholder="Nhập nội dung"
                            rows={5}
                            name="message"
                            value={message}
                            onChange={(value) => {
                                setMessage(value);
                            }}
                            enableCheckValid={readyToValidate}
                            isValid={Utils.isValid(message)}
                            isTouched={readyToValidate}
                        />
                    </div>
                </div>
            </div>
            {/* actions */}
            <div
                className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
                {UIHelper.buildGreenButton(
                    !editMode ? 'Thêm' : 'Cập nhật',
                    handleSubmit,
                    null,
                    false,
                    loading
                )}
            </div>
        </div>
    );
}

export default DialogNotificationAddView;
